import { useMutation } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";
import type { SaveDraftParams } from "./types";

/**
 * Composable for saving email drafts.
 */
export function useSaveDraft() {
  const saveDraftMutation = useMutation({
    mutationFn: async (params: SaveDraftParams) => {
      const response = await Unipile.createDraft(params.payload);
      return response.data;
    },
  });

  return {
    saveDraft: saveDraftMutation.mutateAsync,
    isSaving: saveDraftMutation.isPending,
    saveError: saveDraftMutation.error,
  };
}
